import {useEffect, useRef, useState} from 'react';
import {tradingService} from '../../../../services/tradingService';

interface InstrumentSpec {
    ctVal: number;
    lotSz: number;
    minSz: number;
    tickSz: number;
}

export function useInstrumentSpec(
    apiKeyId: number | null | undefined,
    instId: string,
    enabled: boolean,
): { spec: InstrumentSpec | null; loading: boolean; error: string | null } {
    const [spec, setSpec] = useState<InstrumentSpec | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const requestSeqRef = useRef(0);

    useEffect(() => {
        if (!enabled || !apiKeyId || !instId) {
            setSpec(null);
            setLoading(false);
            setError(null);
            return;
        }

        const seq = ++requestSeqRef.current;
        setLoading(true);
        setError(null);

        tradingService.getInstrumentOverview(instId, apiKeyId, ['5m'])
            .then((overview: any) => {
                if (seq !== requestSeqRef.current) return;
                const data = overview?.data ?? overview;
                const ctVal = Number(data?.ctVal);
                const lotSz = Number(data?.lotSz);
                const minSz = Number(data?.minSz);
                const tickSz = Number(data?.tickSz);
                if (Number.isFinite(ctVal) && 0 < ctVal
                    && Number.isFinite(lotSz) && 0 < lotSz
                    && Number.isFinite(minSz) && 0 < minSz
                    && Number.isFinite(tickSz) && 0 < tickSz) {
                    setSpec({
                        ctVal,
                        lotSz,
                        minSz,
                        tickSz,
                    });
                } else {
                    setSpec(null);
                    setError('合约规格数据不完整');
                }
                setLoading(false);
            })
            .catch(() => {
                if (seq === requestSeqRef.current) {
                    setError('获取合约规格失败');
                    setLoading(false);
                }
            });

        return () => {
            requestSeqRef.current++;
        };
    }, [enabled, apiKeyId, instId]);

    return {spec, loading, error};
}
